import { render, staticRenderFns } from "./AuthStepBasic.vue?vue&type=template&id=16d85cce"
import script from "./AuthStepBasic.vue?vue&type=script&lang=ts"
export * from "./AuthStepBasic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports